// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2690":"3b2c228d","5282":"3b2c228d","7017":"3b2c228d"}[chunkId] + ".chunk.css";
};